<template>
  <div>
    <vue-headful
      title="Subject Details | Gradely.ng - School"
      description="Description goes here"
    />

    <div class="subject-details-section base-type-layout">
      <div class="header-section brand_navy_bg">
        <div class="container px-0">
          <div class="row">
            <div class="col-12">
              <!-- BACK NAV -->
              <router-link
                :to="{ name: 'SchoolSettingsPreferencesSubjects' }"
                class="header-back-nav d-flex justify-content-start align-items-center nowrap rounded-15 pl-1 py-1"
                title="Back to Subjects"
              >
                <!-- ICON -->
                <div class="avatar back-icon">
                  <span
                    class="icon-caret-left color_grey_light font-12 flex-center mr-3"
                  ></span>
                </div>
                <!-- TEXT -->
                <div
                  class="nav-text text-uppercase font-weight-bold color_grey_light"
                >
                  Back To Subjects
                </div>
              </router-link>
              <!-- BACK NAV -->

              <!-- SUBJECT LIST -->
              <div
                class="data-row d-flex justify-content-between align-items-center nowrap"
              >
                <router-link
                  :to="{ name: 'SchoolSettingsPreferencesSubjects' }"
                  class="mobile-back-nav d-flex justify-content-start align-items-center rounded-15 pl-1 py-1 d-md-none"
                  title="Back to Subjects"
                >
                  <!-- ICON -->
                  <div class="avatar back-icon">
                    <span
                      class="icon-caret-left color_grey_light font-12 flex-center mr-3"
                    ></span>
                  </div>
                </router-link>

                <div
                  class="subject-title-row pointer d-inline-flex align-items-center position-relative"
                  v-on-clickaway="onDrop"
                  @click="toggleSubjectList"
                >
                  <div class="subject-title brand_white font-weight-bold">
                    {{ currentSubject.name }}
                  </div>
                  <!-- DROPDOWN INDICATOR -->
                  <div class="subject-dropdown-indicator">
                    <div class="avatar">
                      <span class="icon-caret-down flex-center"></span>
                    </div>
                  </div>
                  <!-- DROPDOWN INDICATOR -->

                  <!-- DROPDOWN -->
                  <div
                    class="dropdown-btn-menu placement-bottom px-0"
                    v-if="show_subject_list"
                  >
                    <ul class="list-unstyled">
                      <li v-for="(subject, index) in subjectList" :key="index">
                        <router-link
                          :to="{
                            name: 'SchoolSettingsSubjectDetails',
                            query: { subject: subject.slug },
                          }"
                          >{{ subject.name }}</router-link
                        >
                      </li>
                    </ul>
                  </div>
                  <!-- DROPDOWN -->
                </div>

                <div class="avatar invisible"></div>
              </div>
              <!-- SUBJECT LIST -->
            </div>
          </div>
        </div>
      </div>

      <!-- CLASS SUBJECTS DETAILS -->
      <div class="container">
        <div class="row px-3 px-sm-0">
          <!-- ASSIGNED CLASS LIST -->
          <div class="left-column d-none d-md-block pr-2">
            <AssignedClassList
              :current_subject="currentSubject"
              @showAssignClass="toggleAssignClass"
            />
          </div>
          <!-- ASSIGNED CLASS LIST -->

          <!-- CLASS LIST MOBILE VIEW -->
          <div
            class="class-list-mobile-view pointer my-3 rounded-5 white w-100 box-shadow-effect"
            @click="toggleClassList"
          >
            <div class="text brand_navy">{{ current_class }}</div>
            <div class="icon-caret-down color_ash font-9"></div>
          </div>
          <!-- CLASS LIST MOBILE VIEW -->

          <!-- TOPIC DATA BY TERM -->
          <div class="right-column white box-shadow-effect rounded-5">
            <div class="subject-intro">
              <div class="class-title font-weight-bold brand_primary">
                {{ current_class }}
              </div>
              <div class="info-text color_ash">
                Organize your topic to fit your curriculum
              </div>
            </div>

            <!-- TOPIC BY TERMS -->
            <TopicListByTerm
              :current_subject="currentSubject"
              :term_title="term.term"
              :topic_list="term.topics"
              :loading="loading"
              v-for="(term, index) in term_topics"
              :key="index"
            />
          </div>
          <!-- TOPIC DATA BY TERM -->
        </div>
      </div>
      <!-- CLASS SUBJECTS DETAILS -->

      <div class="bottom-section w-100 index-9 px-2">
        <div class="container">
          <div class="row d-dlex justify-content-end align-items-center nowrap">
            <button
              class="btn btn-md btn-accent mr-0"
              ref="publishBtn"
              @click="publishChanges"
            >
              Publish Changes
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <DeleteTopicModal
      v-if="delete_topic"
      @confirmTopicDelete="deleteTopicFromList"
      @closeTriggered="toggleDeleteTopicModal"
    />

    <SubjectToClassModal
      :subject_id="currentSubject.id"
      :subject_name="currentSubject.name"
      v-if="show_assign_class"
      @closeTriggered="toggleAssignClass"
    />

    <SelectClassModal
      :current_subject="currentSubject"
      v-if="show_class_list"
      @showAssignClass="toggleAssignClass"
      @closeTriggered="toggleClassList"
    />
    <!-- MODAL -->

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import AssignedClassList from "@/components/globalComps/SettingsComps/SubjectComps/AssignedClassList";

export default {
  name: "SchoolSubjectTopicDetails",

  mixins: [clickaway],

  components: {
    AssignedClassList,
    TopicListByTerm: () =>
      import(
        /* webpackChunkName: "TopicListByTerm" */ "@/components/globalComps/SettingsComps/SubjectComps/TopicListByTerm"
      ),
    DeleteTopicModal: () =>
      import(
        /* webpackChunkName: "DeleteTopicModal" */
        "@/components/modalComps/settingsModals/DeleteTopicModal"
      ),
    SubjectToClassModal: () =>
      import(
        /* webpackChunkName: "SubjectToClassModal" */
        "@/components/modalComps/settingsModals/SubjectToClassModal"
      ),
    SelectClassModal: () =>
      import(
        /* webpackChunkName: "SelectClassModal" */
        "@/components/modalComps/settingsModals/SelectClassModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    ...mapGetters([
      "getCurrentClassSubject",
      "getCurrentSchoolClass",
      "getCurrentGlobalClass",
    ]),
  },

  data() {
    return {
      show_subject_list: false,
      show_assign_class: false,
      show_class_list: false,
      subjectList: [],
      box_offset: 0,
      current_class: "Loading...",
      loading: true,

      currentSubject: {
        id: null,
        name: "Loading...",
        slug: "",
        description: "",
        assigned_classes: [],
      },

      term_topics: [
        { term: "first", topics: [] },
        { term: "second", topics: [] },
        { term: "third", topics: [] },
      ],

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,

      delete_topic: false,
      delete_id: null,
      delete_term: null,
      topic_data_id: null,
      is_custom: 0,
    };
  },

  watch: {
    $route: {
      handler(newVal) {
        if (newVal) {
          this.fetchSubjectDetails();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.$bus.$on("event-bus-reload-subject-list", this.fetchSubjectDetails);
    this.$bus.$on("event-bus-topic-drop", this.sortTopicList);
    this.$bus.$on(
      "event-bus-remove-topic",
      ({ id, topic_data_id, term, is_custom }) => {
        this.delete_id = id;
        this.delete_term = term;
        this.topic_data_id = topic_data_id;
        this.is_custom = is_custom;

        this.toggleDeleteTopicModal();
      }
    );

    this.$bus.$on("add-selected-topics", this.addSelectedTopicToList);
  },

  methods: {
    ...mapActions([
      "getSubjectInfo",
      "getSubjectTopics",
      "setCurrentClassInfo",
      "deleteTopic",
      "updateTopicOrder",
    ]),

    toggleAssignClass() {
      4;
      if (this.show_class_list) this.show_class_list = false;
      this.show_assign_class = !this.show_assign_class;
    },

    toggleClassList() {
      this.show_class_list = !this.show_class_list;
    },

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    popUpAlert(msg, type) {
      this.alert_card_msg = msg;
      this.alert_card_type = type;
      this.toggleResponseDialog();
    },

    sortTopicList({ from, to, offset }) {
      console.log(from, to, offset);
      let from_term = from.split("_")[0];
      let from_index = Number(from.split("_")[1]);

      let to_term = null;
      let to_index = null;

      // IF TO IS NOT NULL
      if (to) {
        // IF LENGTH OF TO IS MORE THAN ONE
        if (to.split("_").length > 1) {
          to_term = to.split("_")[0];
          to_index = Number(to.split("_")[1]);
        }
        // IF LENGTH OF TO IS ONE
        else to_term = to.split("_")[0];
      } else to_term = from_term;

      // GET ELEMENT DATA
      let topic_item = this.getElement(from_term, from_index);
      this.removeElement(from_term, from_index);

      // IF DESTINATION AND OFFSET IS NEGATIVE OR 0
      if (to_index && Math.sign(offset) === -1) {
        this.addBeforeElement(to_term, to_index, topic_item);
      }
      // IF DESTINATION AND OFFSET IS POSITIVE
      else if (to_index && Math.sign(offset) === 1) {
        this.addAfterElement(to_term, to_index, topic_item);
      }
      // IF NO DESTINATION AND OFFSET IS NEGATIVE
      else if (
        !to_index &&
        (Math.sign(offset) === -1 || Math.sign(offset) === 0)
      ) {
        this.addElementToFirst(to_term, topic_item);
      }
      // IF NO DESTINATION AND OFFSET IS POSITIVE
      else if (!to_index && Math.sign(offset) === 1) {
        this.addElementToLast(to_term, topic_item);
      } else this.addElementToFirst(to_term, topic_item);
    },

    getTermIndex(term) {
      if (term === "first") return 0;
      else if (term === "second") return 1;
      else return 2;
    },

    removeElement(term, index) {
      let term_index = this.getTermIndex(term);
      this.term_topics[term_index].topics.splice(index, 1);
    },

    addBeforeElement(term, index, item) {
      let term_index = this.getTermIndex(term);
      this.term_topics[term_index].topics.splice(index, 0, item);
    },

    addAfterElement(term, index, item) {
      let term_index = this.getTermIndex(term);
      this.term_topics[term_index].topics.splice(index + 1, 0, item);
    },

    getElement(term, index) {
      let term_index = this.getTermIndex(term);
      return this.term_topics[term_index].topics[index];
    },

    addElementToLast(term, item) {
      let term_index = this.getTermIndex(term);
      this.term_topics[term_index].topics.push(item);
    },

    addElementToFirst(term, item) {
      let term_index = this.getTermIndex(term);
      this.term_topics[term_index].topics.unshift(item);
    },

    fetchSubjectDetails() {
      this.getSubjectInfo(this.$route.query.subject)
        .then((response) => {
          //   console.log(response);
          this.subjectList = response.subjects;
          this.currentSubject = {
            id: response.current_subject.id,
            name: response.current_subject.name,
            slug: response.current_subject.slug,
            description: response.current_subject.description,
            assigned_classes: response.current_subject.classes,
          };

          this.updateCurrentClassInfo(this.currentSubject.id);
        })
        .catch((error) => {
          console.log(error);
          this.current_class = "No class assigned";
          this.loading = false;
        });
    },

    updateCurrentClassInfo(subject_id) {
      if (this.$route.query.class_id) {
        let class_info = this.currentSubject.assigned_classes.filter(
          (item) => item.id == this.$route.query.class_id
        );
        this.current_class = class_info[0].class_name;

        this.updateCurrentClassState(subject_id, class_info[0]);
      } else {
        let current_class_data = this.currentSubject.assigned_classes[0];

        this.current_class = current_class_data.class_name;
        this.updateCurrentClassState(subject_id, current_class_data);
      }
    },

    // UPDATE THE STORE STATE
    updateCurrentClassState(subject_id, class_data) {
      this.setCurrentClassInfo({
        subject_id: subject_id,
        school_class_id: class_data.id,
        global_class_id: class_data.global_class_id,
      });

      // FETCH ALL CLASS TOPIC LIST
      this.fetchClassTopicList();
    },

    // GET CURRENT CLASS SUBJECT TOPICS
    fetchClassTopicList() {
      let class_data = {
        subject: this.getCurrentClassSubject,
        school_class: this.getCurrentSchoolClass,
        global_class: this.getCurrentGlobalClass,
      };

      this.getSubjectTopics(class_data)
        .then((response) => {
          // console.log("Topic LIst", response.data)
          this.term_topics = response.data;
          this.loading = false;

          this.is_custom = this.term_topics[0].topics[0].is_custom;
        })
        .catch((err) => console.log(err));
    },

    addSelectedTopicToList({ term, topics, create }) {
      let term_index = this.getTermIndex(term);

      create
        ? this.term_topics[term_index].topics.push(topics)
        : this.term_topics[term_index].topics.push(...topics.flat());

      if (create)
        this.popUpAlert("Topic created has been added to list", "success");
      else {
        if (topics.length > 1)
          this.popUpAlert("Selected topic has been added to list", "success");
        else
          this.popUpAlert("Selected topics has been added to list", "success");
      }
    },

    deleteTopicFromList() {
      let term_index = this.getTermIndex(this.delete_term);

      let topic_index = this.term_topics[term_index].topics.findIndex(
        (topic) => Number(topic.topic_id) === this.topic_data_id
      );

      this.term_topics[term_index].topics.splice(topic_index, 1);

      // CALL TOPIC DELETE ENDPOINT
      this.deleteTopic({ id: this.delete_id, is_custom: this.is_custom })
        .then((response) => {
          if (response.code === 200) {
            this.popUpAlert("Topic has been successfully deleted!", "success");
            this.is_custom = 1;
          } else
            this.popUpAlert("An error occured while deleting topic", "error");
        })
        .catch((err) => console.log(err));
    },

    publishChanges() {
      this.$refs.publishBtn.disabled = true;
      this.$refs.publishBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      let topics = {
        first: this.term_topics[0].topics,
        second: this.term_topics[1].topics,
        third: this.term_topics[2].topics,
      };

      let data = {
        is_custom: this.is_custom,
        subject: this.getCurrentClassSubject,
        school_class: this.getCurrentSchoolClass,
        topics,
      };

      this.updateTopicOrder(data)
        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            setTimeout(() => {
              this.$refs.publishBtn.disabled = false;
              this.$refs.publishBtn.innerHTML = "Publish Changes";

              this.popUpAlert("Topic re-ordered successfully", "success");
              this.fetchSubjectDetails();
            }, 2500);
          } else {
            setTimeout(() => {
              this.$refs.publishBtn.disabled = false;
              this.$refs.publishBtn.innerHTML = "Publish Changes";
              this.popUpAlert(
                "An error occured while re-ordering topics",
                "error"
              );
            }, 2000);
          }
        })
        .catch((err) => console.log(err));
    },

    toggleDeleteTopicModal() {
      this.delete_topic = !this.delete_topic;
    },

    toggleSubjectList() {
      this.show_subject_list = !this.show_subject_list;
    },

    onDrop() {
      this.show_subject_list = false;
    },
  },
};
</script>

<style lang="scss">
.subject-details-section {
  position: relative;
  top: 60px;

  @include breakpoint_max(md) {
    margin-bottom: 70px;
  }

  .header-section {
    padding: 30px 0 40px;
    margin-bottom: 50px;

    @include breakpoint_max(md) {
      padding: 17px 0;
      margin-bottom: 20px;
    }

    @include breakpoint_max(sm) {
      padding: 14px 0;
    }

    .header-back-nav,
    .mobile-back-nav {
      width: 190px;
      margin-bottom: 25px;
      transition: all 0.4s ease-in-out;

      @include breakpoint_max(md) {
        display: none !important;
      }

      .nav-text {
        font-size: 14px;
        transition: all 0.4s ease-in-out;
      }

      &:hover {
        background: darken($brand_primary, 14%) !important;
        .nav-text {
          color: $brand_accent !important;
        }
      }
    }

    .mobile-back-nav {
      @include breakpoint_max(md) {
        width: 40px;
        display: flex !important;
        margin-bottom: 0;
      }
    }

    .subject-title-row {
      .subject-title {
        font-size: 28px;
        line-height: 42px;
        margin-right: 20px;

        @include breakpoint_max(lg) {
          font-size: 18px;
        }

        @include breakpoint_max(md) {
          font-size: 16px;
        }

        @include breakpoint_max(sm) {
          font-size: 15px;
        }
      }
      .subject-dropdown-indicator {
        .avatar {
          @include equal_min_edge(32);
          background: $brand_white;
          border: 1px solid $brand_inverse;
          transition: all 0.4s ease-in-out;

          @include breakpoint_max(lg) {
            @include equal_min_edge(30);
          }

          @include breakpoint_max(md) {
            @include equal_min_edge(25);
          }

          @include breakpoint_max(sm) {
            @include equal_min_edge(22);
          }

          span {
            color: $brand_inverse;
            font-size: 12px;
            position: relative;
            top: 60%;
            left: 48.5%;
            transform: translate(-50%, -50%);
            transition: all 0.4s ease-in-out;

            @include breakpoint_max(md) {
              font-size: 10px;
            }
          }
        }
      }
      &:hover {
        .subject-dropdown-indicator {
          .avatar {
            border: 1px solid $brand_accent;
            span {
              color: $brand_accent;
            }
          }
        }
      }

      .placement-bottom {
        top: 41px;
      }

      .dropdown-btn-menu {
        width: auto;
        li > a {
          padding-top: 11px;
          padding-bottom: 11px;
          font-size: 14.5px;
          color: $color_grey_dark !important;

          @include breakpoint_max(md) {
            font-size: 13px;
            padding-top: 9px;
            padding-bottom: 9px;
          }
        }
      }
    }
  }

  .left-column {
    flex: 0 0 37%;
    max-width: 37%;
  }

  .class-list-mobile-view {
    @include flex_row_between_nowrap;
    padding: 13px 15px;

    .text {
      font-size: 14px;
      line-height: 19px;
    }

    @include breakpoint_min(md) {
      display: none;
    }
  }

  .right-column {
    flex: 0 0 63%;
    max-width: 63%;
    margin-bottom: 120px;

    @include breakpoint_max(md) {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .subject-intro {
      padding: 20px 30px;

      @include breakpoint_max(lg) {
        padding: 17px 20px;
      }
      @include breakpoint_max(xs) {
        padding: 17px 15px;
      }
      .class-title {
        font-size: 18.5px;
        line-height: 29px;
        margin-bottom: 2px;

        @include breakpoint_max(lg) {
          font-size: 16px;
          line-height: 18px;
        }

        @include breakpoint_max(xs) {
          font-size: 15px;
        }
      }

      .info-text {
        font-size: 12.5px;
        line-height: 19px;

        @include breakpoint_max(lg) {
          font-size: 11.5px;
          line-height: 15px;
        }
      }
    }
  }

  .bottom-section {
    background: darken($brand_navy, 5%);
    padding: 10px 0;
    position: fixed;
    bottom: 0;
  }
}
</style>
